import React, { Component } from 'react';
import { isEmpty, getGuestRoomIcon, addAnimation } from '../../../Common/Common';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Editbox from '../../../Part_Sample/Editbox';
import Modal from '../../../Part_Sample/Modal';
import Button from '../../../Part_Sample/Button';
import Room_Selection_Cell from '../Components/Room_Selection_Cell';
import Room_Reorder_Cell from '../Components/Room_Reorder_Cell';

import order_up_icon from '../../../../Images/Daikin_Images/image/up.png';
import order_down_icon from '../../../../Images/Daikin_Images/image/down.png';

export default class Add_Edit_Location extends Component {
	constructor(props) {
		super(props);
		// Set default guest_room_setting in case of first time open
		this.guest_room_settings = {
			locations: [],
			rooms: {}
		};
		// Default current location detail
		let location_detail = {
			name: '',
			room_order: [],
		}
		// If setting is not empty, set the current location details
		if (!isEmpty(this.props.param.guest_room_settings)) {
			this.guest_room_settings = JSON.parse(JSON.stringify(this.props.param.guest_room_settings));
			if (this.props.param.index != null) {
				location_detail = this.guest_room_settings.locations[this.props.param.index];
			}
		}

		this.guest_rooms = {};
		// Set up display for rooms selection
		let rooms_selection = [];

		if (!isEmpty(this.props.param.guest_rooms)) {
			this.guest_rooms = JSON.parse(JSON.stringify(this.props.param.guest_rooms));

			let guest_room_names = Object.keys(this.props.param.guest_rooms);
			for (let room_name of guest_room_names) {
				let room_detail = {};
				room_detail.name = room_name;
				room_detail.icon = null;
				if (!isEmpty(this.guest_room_settings.rooms[room_name])) {
					room_detail.icon = this.guest_room_settings.rooms[room_name].icon;
				}
				room_detail.is_selected = false;
				if (location_detail.room_order.includes(room_name)) {
					room_detail.is_selected = true;
				}

				rooms_selection.push(room_detail);
			}
		}

		// Check if rooms already selected in other locations
		let already_selected_rooms = [];
		for (let index in this.guest_room_settings.locations) {
			let temp_location_detail = this.guest_room_settings.locations[index];
			if (!isEmpty(temp_location_detail)) {
				if (index != this.props.param.index) {
					already_selected_rooms = already_selected_rooms.concat(temp_location_detail.room_order);
				}
			}
		}



		for (let i in rooms_selection) {
			if (already_selected_rooms.includes(rooms_selection[i].name)) {
				rooms_selection[i].is_selected = false;
				rooms_selection[i].is_disabled = true;
			} else {
				rooms_selection[i].is_disabled = false;
			}
		}

		this.state = {
			location_detail: location_detail,
			rooms_selection: rooms_selection,
			is_show_modal: false,

			// For reordering the list of rooms
			selected_room_for_reorder: null
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Locations', this.props.param);
	}

	handleChangeName = (val) => {
		let location_detail = JSON.parse(JSON.stringify(this.state.location_detail));
		location_detail.name = val;
		this.setState({
			location_detail: location_detail
		})
	}

	handleToggleModal = () => {
		let is_show_modal = !this.state.is_show_modal;
		if (is_show_modal) {
			window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		} else {
			window.app.content_area.current.switch_content.current.handleShowBottomControls();
		}
		this.setState({ is_show_modal: !this.state.is_show_modal });
	}

	handleSetToggle = (room_index) => {
		let rooms_selection = JSON.parse(JSON.stringify(this.state.rooms_selection));
		if (rooms_selection[room_index].is_disabled) {
			return;
		}

		if (rooms_selection[room_index].is_selected) {
			rooms_selection[room_index].is_selected = false;
		} else {
			rooms_selection[room_index].is_selected = true;
		}

		this.setState({ rooms_selection: rooms_selection })
	}

	handleConfirmRooms = () => {
		let rooms_selection = JSON.parse(JSON.stringify(this.state.rooms_selection));
		let location_detail = JSON.parse(JSON.stringify(this.state.location_detail))
		for (let room_detail of rooms_selection) {
			if (room_detail.is_selected) {
				if (!location_detail.room_order.includes(room_detail.name)) {
					location_detail.room_order.push(room_detail.name)
				}
			} else {
				if (location_detail.room_order.includes(room_detail.name)) {
					let index = location_detail.room_order.indexOf(room_detail.name);
					location_detail.room_order.splice(index, index + 1);
				}
			}
		}

		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.setState({
			location_detail: location_detail,
			is_show_modal: false,
		})
	}

	handleSelectRoomForReorder = (room_index) => {
		this.setState({ selected_room_for_reorder: room_index })
	}

	handleChangePosition = (direction) => {
		let element = document.getElementById(direction);
		addAnimation(element, 'fadeIn', () => { }, 300);

		let new_index = this.state.selected_room_for_reorder;
		if (new_index == null) return;

		let location_detail = JSON.parse(JSON.stringify(this.state.location_detail))
		let new_room_order = [...this.state.location_detail.room_order];

		if (direction == 'up') {
			// if this is the first element, dont swap
			if (new_index - 1 >= 0) {
				new_index = new_index - 1;
				this.swapPosition(new_room_order, this.state.selected_room_for_reorder, new_index);
			}
		} else if (direction == 'down') {
			// if this is the first element, dont swap
			if (new_index + 1 < new_room_order.length) {
				new_index = new_index + 1;
				this.swapPosition(new_room_order, this.state.selected_room_for_reorder, new_index);
			}
		}

		location_detail.room_order = new_room_order;

		this.setState({
			location_detail: location_detail,
			selected_room_for_reorder: new_index,
		})
	}

	swapPosition = (array, x, y) => {
		let b = array[y];
		array[y] = array[x];
		array[x] = b;
	}

	handleRegister = () => {
		if (this.state.location_detail.name == '') {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		if (this.props.param.index != null) {
			this.guest_room_settings.locations[this.props.param.index] = this.state.location_detail;
		} else {
			this.guest_room_settings.locations.push(this.state.location_detail);
		}

		window.app.showLoading();
		this.props.receiver.saveJSONFile({ name: 'guest_room_settings.json', data: this.guest_room_settings });
	}

	handleDelete = () => {
		this.guest_room_settings.locations.splice(this.props.param.index, 1);
		this.props.receiver.saveJSONFile({ name: 'guest_room_settings.json', data: this.guest_room_settings });
	}

	rcvSaveJSONFile = (data) => {
		window.app.hideLoading();
		if (data.result == 'OK') {
			window.app.content_area.current.switch_content.current.handleHideBottomMenu();
			let param = JSON.parse(JSON.stringify(this.props.param));
			param.guest_room_settings = this.guest_room_settings;
			this.props.content_handler('Locations', param);
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let reorder_container_height = this.props.height - 310;
		if (reorder_container_height < 200) reorder_container_height = 200;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.index != null ? this.props.receiver.getString('edit_location') : this.props.receiver.getString('add_location')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ overflow: 'auto', height: this.props.height - 120 }}>
						<div style={{ width: this.props.width - 20, marginLeft: 10 }}>
							<Editbox id='location_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeName(event.target.value)} value={this.state.location_detail.name} />
						</div>
						<div style={{ verticalAlign: 'top', marginLeft: 'auto', marginRight: 'auto', marginTop: 20, width: this.props.width - 100 }}>
							<Button id='toggle_modal' style={{ color: '#6e6e6e', width: '100%', margin: 0, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={'white'} onClick={this.handleToggleModal}>{this.props.receiver.getString('select_rooms')}</Button>
						</div>
						<div style={{ display: this.state.location_detail.room_order.length > 0 ? 'block' : 'none', width: this.props.width - 20, marginLeft: 10, marginTop: 10, maxHeight: 50 }}>
							<span className='footnote' style={{ textAlign: 'left' }}>{this.props.receiver.getString('guest_room_reorder_expl')}</span>
						</div>
						<div style={{ minHeight: 100, width: this.props.width - 20, marginLeft: 10, marginRight: 10, textAlign: 'left' }}>
							<div style={{ display: 'inline-block', width: this.props.width - 70, marginRight: 10, verticalAlign: 'top', overflow: 'auto', height: reorder_container_height }}>
								{this.state.location_detail.room_order.map((room_name, room_index) => {
									let icon = null;
									if (!isEmpty(this.guest_room_settings.rooms[room_name])) {
										icon = this.guest_room_settings.rooms[room_name].icon;
									}
									let is_selected = false;
									if (this.state.selected_room_for_reorder == room_index) is_selected = true;

									return (
										<Room_Reorder_Cell
											width={this.props.width}
											room_name={room_name}
											room_icon={icon}
											room_index={room_index}
											is_selected={is_selected}
											handleSetToggle={this.handleSelectRoomForReorder}
											colours={this.props.colours}
										/>
									)
								})}
							</div>
							<div style={{ display: this.state.location_detail.room_order.length > 0 ? 'inline-block' : 'none', width: 40 }}>
								<div id='up' style={{ height: (reorder_container_height) / 2 }} onClick={() => { this.handleChangePosition('up') }}>
									<div style={{ height: (reorder_container_height) / 6 }}>
										<img src={order_up_icon} style={{ width: 40, }} />
									</div>
								</div>
								<div id='down' style={{ height: (reorder_container_height) / 2 }} onClick={() => { this.handleChangePosition('down') }}>
									<div style={{ height: (reorder_container_height) / 6, paddingTop: (reorder_container_height) / 2 - 80, }}>
										<img src={order_down_icon} style={{ width: 40, }} />
									</div>
								</div>
							</div>
						</div>
						<Modal position={"unset"} width={"100%"} height={this.props.height} is_show={this.state.is_show_modal} handleToggle={this.handleToggleModal}>
							<div style={{ padding: 20 }}>
								<span style={{ fontWeight: 600 }}>{this.props.receiver.getString('select_rooms')}</span>
							</div>
							{this.state.rooms_selection.map((room_detail, room_index) => {
								return (
									<Room_Selection_Cell
										width={this.props.width}
										room_index={room_index}
										room_detail={room_detail}
										handleSetToggle={this.handleSetToggle}
									/>
								)
							})}
							<Button id='modal_confirm' style={{ width: this.props.width - 20, margin: 0, marginTop: 20, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={this.props.colours.appBlue} onClick={this.handleConfirmRooms}>{this.props.receiver.getString('confirm')}</Button>
						</Modal>
					</div>
				</div>
			</div>
		)
	}
}